import React from 'react';

import { Reviewer } from '../../PrimaryNavigation';
import styles from '../../PrimaryNavigation.module.scss';
import AdminSection from './components/AdminSection';
import OrganizationSection from './components/OrganizationSection';
import PlanBadge from './components/PlanBadge';
import {
  Heading,
  MenuTrigger,
  MenuButton,
  MenuPopover,
  MenuList,
  MenuItem,
  MenuSeparator,
  Text,
} from 'components/core';
import { Stack } from 'components/layout';

interface Props {
  reviewer: Reviewer;
  children: React.ReactNode;
}

const ProfileDropdown = ({ reviewer, children }: Props) => {
  const account = reviewer.account;
  const organizations = reviewer.organizations || [];
  const isTrial = ['Trial', 'Short Trial'].includes(account.plan.name);
  const isAdmin = reviewer.admin || false;
  const canProxy = reviewer.can_proxy;

  return (
    <MenuTrigger>
      <MenuButton
        className={styles.PrimaryNavigation_menuButton}
        data-testid="profileDropdownButton"
        aria-label="Profile menu"
        isNaked
        iconOnly
      >
        {children}
      </MenuButton>
      <MenuPopover placement="bottom end">
        {/* Static elements must be outside the MenuList */}
        <Stack
          spacing={2}
          className={styles.PrimaryNavigation_staticMenuContent}
        >
          <Heading type="h5" component="p">
            {reviewer.first_name} {reviewer.last_name}
          </Heading>
          <Text size="sm" variant="weak">
            {reviewer.email}
          </Text>
        </Stack>
        <MenuList>
          <MenuItem href="/profile">Profile</MenuItem>
          {isTrial ? (
            <MenuItem href="/plans">
              Choose a plan
              <PlanBadge plan={account.plan} />
            </MenuItem>
          ) : (
            <MenuItem href="/account">
              Billing and plan
              <PlanBadge plan={account.plan} />
            </MenuItem>
          )}
          <MenuSeparator />
          <OrganizationSection organizations={organizations} />
          <MenuItem href="/sign_out">Sign out</MenuItem>
        </MenuList>
        <AdminSection isAdmin={isAdmin} canProxy={!!canProxy} />
      </MenuPopover>
    </MenuTrigger>
  );
};

export default ProfileDropdown;
